import Building from '@models/building/Building'
import Unit from '@models/building/Unit'
import Unitairvolume from '@models/airvolumes/Unitairvolume'
import Roomairvolume from '@models/airvolumes/Roomairvolume'
import store from '@store'
import Systemselection from '@models/airvolumes/Systemselection'
import Installation from '@models/airvolumes/Installation'
import Valve from '@models/airvolumes/Valve'
import RoomtypesHasOperationmodesHasAirvolume from '@models/helpers/RoomtypesHasOperationmodesHasAirvolume'
import RoomltmsHasOperationmode from '@models/helpers/RoomltmsHasOperationmode'

export default {
  calculate(unitId = null) {
    this.building = Building.query().first()
    this.unit = Unit.query().where('id', unitId).with(['airvolume', 'installation', 'systemselection', 'rooms.airvolume', 'rooms.valve']).first()

    if (this.unit.airvolumeUpdate == 'loaded') {
      this.getConstants();
      this.basicCalculations();
      this.fZuCalculation();
      this.calculateTotalOperationmodeAir()

      this.calculateTotalAirvolumes();
      this.calculateAirvolumeVariations();
      Unit.insertOrUpdate({data: [this.unit]})
      return;
    }
    if (this.unit.rooms.length <= 0) return

    if (this.unit.airvolume == null) {
      this.unit.airvolume = new Unitairvolume({unitId: this.unit.id})
    }
    if (this.unit.systemselection == null) {
      this.unit.systemselection = new Systemselection({
        unitId: this.unit.id,
        deviceLevel: this.unit.level,
      })
    }
    if (this.unit.installation == null) {
      this.unit.installation = new Installation({
        unitId: this.unit.id,
        storey: this.unit.storey,
      })
    }
    this.unit.rooms.forEach((room) => {
      if (room.airvolume == null) {
        room.airvolume = new Roomairvolume({roomId: room.id, doorLeaf: room.getRoomtypeDoorLeaf()})
      }
      if (room.airvolume.doorLeaf == 0 || room.airvolume.doorLeaf == null) {
        room.airvolume.doorLeaf = room.getRoomtypeDoorLeaf()
      }
      if (room.valve == null) {
        room.valve = new Valve({roomId: room.id})
      }
      if (room.airType == 3) room.airvolume.resetOverflowRoom()
    })

    this.getConstants()
    this.basicCalculations()
    this.fZuCalculation()

    this.setDefaultOperationmode()
    this.calculateTotalOperationmodeAir()
    this.totalExhaustAirCalculation()
    this.calculateEquation8()
    if (this.unit.airvolume.manually != 1) {
      this.i = 0
      this.calculateSupplyAir()
      this.calculateExhaustAir()
    }

    this.calculateTotalAirvolumes()
    this.calculateAirvolumeVariations()

    this.calculateUld()
    this.calculateValves()

    this.unit.deleteArticles()
    Unit.insertOrUpdate({data: [this.unit]})
    return
  },

  getConstants() {
    this.fLstnl = store.getters['constants/getFlstnl']
    this.fLstil = store.getters['constants/getFlstil']
    this.fLstrl = store.getters['constants/getFlstrl']
    this.fLstfl = store.getters['constants/getTable6Constant']({
      buildingHeatProtection: this.building.heatProtection,
      unitOccupancy: this.unit.occupancy
    })
  },

  basicCalculations() {
    this.unit.airvolume.space = 0
    this.unit.airvolume.height = 0
    this.unit.airvolume.volume = 0

    this.unit.rooms.forEach(
      function (room) {
        if (room.ventilationMeasure != 6) this.unit.airvolume.space += room.space
        this.unit.airvolume.height += room.height
      }.bind(this)
    )

    this.unit.airvolume.height = this.unit.airvolume.height / this.unit.rooms.length
    this.unit.airvolume.volume = +parseFloat((this.unit.airvolume.space * this.unit.airvolume.height).toFixed(2))
  },

  /*  fZuCalculation() {
      this.unit.airvolume.totalFrZu = 0
      this.unit.airvolume.totalFrZuKorr = 0
      this.unit.rooms.forEach((room) => {
        room.airvolume.setFZu()
        this.unit.airvolume.totalFrZu += room.airvolume.fZu
        this.unit.airvolume.totalFrZuKorr += room.airvolume.fZuKorr
      })
    },*/
  fZuCalculation() {
    let totalFrZu = this.unit.airvolume.totalFrZu;
    let newTotalFrZu = 0;
    this.unit.airvolume.totalFrZu = 0;
    this.unit.airvolume.totalFrZuKorr = 0;
    let reset = false;
    this.unit.rooms.forEach((room) => {
      if (room.airType != 2 || room.ventilationMeasure == 2) return;
      if (room.airvolume.fZu === null || room.airvolume.fZu <= null) {
        reset = true;
        return;
      }
      newTotalFrZu += room.airvolume.fZu;
    });
    if (newTotalFrZu != totalFrZu) reset = true;
    this.unit.rooms.forEach((room) => {
      if (reset === true) room.airvolume.resetFZu = true;
      room.airvolume.setFZu();
      this.unit.airvolume.totalFrZu += room.airvolume.fZu;
      this.unit.airvolume.totalFrZuKorr += room.airvolume.fZuKorr;
    });
  },

  setDefaultOperationmode() {
    this.unit.rooms.forEach((room) => {
      if (room.airvolume.operationmode == null || room.airvolume.operationmode <= 0 || !RoomltmsHasOperationmode.query().where('roomltms_id', room.ventilationMeasure).where('operationmodes_id', room.airvolume.operationmode).exists()) {
        var operationmode = RoomltmsHasOperationmode.query().where('roomltms_id', room.ventilationMeasure).where('default', 1).first()
        room.airvolume.operationmode = operationmode.operationmodes_id
        var operationmodeAirvolume = RoomtypesHasOperationmodesHasAirvolume.query().where('operationmodes_id', room.airvolume.operationmode).where('roomtypes_id', room.type).where('window', +room.window).where('default', true).first()
        if (operationmodeAirvolume != undefined || operationmodeAirvolume != null) {
          room.airvolume.operationmodeAirvolume = operationmodeAirvolume.id
        }
      }
    })
  },

  calculateTotalOperationmodeAir() {
    this.unit.airvolume.totalNeedAir = 0
    this.unit.airvolume.totalDurationAir = 0
    this.unit.rooms.forEach(
      function (room, index) {
        if (room.airvolume.operationmodeAirvolume == null || room.airvolume.operationmodeAirvolume <= 0 || !(room.ventilationMeasure == 1 || room.ventilationMeasure == 6)) return
        var operationmodeAirvolume = RoomtypesHasOperationmodesHasAirvolume.find(room.airvolume.operationmodeAirvolume)
        this.unit.airvolume.totalNeedAir += operationmodeAirvolume.need_airvolume
        this.unit.airvolume.totalDurationAir += operationmodeAirvolume.duration_airvolume
      }.bind(this)
    )
  },

  totalExhaustAirCalculation() {
    this.unit.airvolume.exhaustAir = 0
    this.unit.rooms.forEach((room) => {
      if (room.airType != 1 || room.ventilationMeasure == 7) return
      this.unit.airvolume.exhaustAir += room.getRoomtypeAirvolume()
    })
  },

  calculateEquation8() {
    if (this.unit.airvolume.space < 210) {
      this.unit.airvolume.nl = this.fLstnl * (-0.002 * Math.pow(this.unit.airvolume.space, 2) + 1.15 * this.unit.airvolume.space + 11)
    } else {
      this.unit.airvolume.nl = ((this.unit.airvolume.space - 210) / 10) * 4 + this.fLstnl * (-0.002 * Math.pow(210, 2) + 1.15 * 210 + 11)
    }
  },

  calculateSupplyAir() {
    this.unit.airvolume.totalSupplyAir = 0;

    this.unit.rooms.forEach((room) => {
      if (room.airType != 2) return;
      room.airvolume.isDefault = false;
      room.airvolume.fZu = room.airvolume.fZuKorr;
      room.airvolume.airvolume = Math.round((this.unit.airvolume.nl / this.unit.airvolume.totalFrZuKorr) * room.airvolume.fZuKorr);
    });

    if (
      this.unit.rooms.some((room) => {
        return (room.airType == 2 && room.getRoomtypeAirvolume() > room.airvolume.airvolume) || Math.abs(room.airvolume.getDefaultFzu() - room.airvolume.fZuKorr) > room.airvolume.getDefaultFzuDelta();
      })
    ) {
      this.intervalCounter = 0;
      this.calculateDefaultSupplyAir();
      this.checkDefaultSupplyAir();
    }
    this.unit.airvolume.totalFrZu = 0;
    this.unit.rooms.forEach((room) => {
      if (room.airType != 2 || room.ventilationMeasure == 2) return;
      if (room.ventilationMeasure == 7) {
        room.airvolume.airvolume = 0;
        return;
      }
      room.airvolume.fZu = room.airvolume.fZuKorr;
      this.unit.airvolume.totalFrZu += room.airvolume.fZu;
      this.unit.airvolume.totalSupplyAir += room.airvolume.airvolume;
    });
  },

  calculateDefaultSupplyAir() {
    let changes = false;
    if (this.intervalCounter == 0) {
      this.unit.rooms.forEach((room) => (room.airvolume.resetFZu = true));
    }
    this.fZuCalculation();

    this.unit.rooms.forEach(
      function (room) {
        if (!(room.airType == 2 || room.ventilationMeasure == 2)) return;
        room.airvolume.airvolume = Math.round((this.unit.airvolume.nl / this.unit.airvolume.totalFrZuKorr) * room.airvolume.fZuKorr);
        if (room.getRoomtypeAirvolume() > room.airvolume.airvolume) {
          changes = true;
          room.airvolume.fZuKorr = +parseFloat((room.getRoomtypeAirvolume() * this.unit.airvolume.totalFrZuKorr) / this.unit.airvolume.nl).toFixed(1);
          return;
        }
      }.bind(this)
    );
    if (changes === true && this.intervalCounter < 10) {
      this.intervalCounter++;
      this.calculateDefaultSupplyAir();
    } else {
      this.intervalCounter = 0;
    }
  },

  checkDefaultSupplyAir() {
    let totalSupplyAir = 0;
    if (this.unit.rooms.some((room) => room.airType == 2 && (room.getRoomtypeAirvolume() > room.airvolume.airvolume || Math.abs(room.airvolume.getDefaultFzu() - room.airvolume.fZuKorr) > room.airvolume.getDefaultFzuDelta()))) {
      this.unit.rooms.forEach((room) => {
        if (room.airType != 2) return;
        room.airvolume.airvolume = room.getRoomtypeAirvolume();
        room.airvolume.isDefault = true;
        totalSupplyAir += room.airvolume.airvolume;
      });
      if (totalSupplyAir > this.unit.airvolume.nl) {
        this.unit.airvolume.nl = totalSupplyAir;
      } else if (totalSupplyAir < this.unit.airvolume.nl) {
        let difference = this.unit.airvolume.nl - totalSupplyAir;
        if (
          !this.unit.rooms.some((room) => {
            if (room.type == 8) {
              room.airvolume.airvolume += Math.round(difference);
              return true;
            } else return false;
          })
        ) {
          let maxSpace = 0;
          let roomId = -1;
          this.unit.rooms.forEach((room, id) => {
            if (room.airType == 2) {
              if (maxSpace < room.space) {
                maxSpace = room.space;
                roomId = id;
              }
            }
          });
          if (roomId >= 0) {
            this.unit.rooms[roomId].space += difference;
          }
        }
      }
    }
  },

  /*
    calculateSupplyAir() {
      let changes = false
      this.total_fr_zu_korr = 0
      this.unit.rooms.forEach(room => {
        if (!(room.airType == 2 || room.ventilationMeasure == 2)) return
        if (room.airvolume.fZu == null || room.airvolume.fZu <= 0) {
          room.airvolume.fZu = +parseFloat(room.getRoomtype().f_zu).toFixed(1)
          room.airvolume.fZuKorr = room.airvolume.fZu
        }
        if (room.airvolume.fZuKorr == null || room.airvolume.fZuKorr <= 0) room.airvolume.fZuKorr = room.airvolume.fZu
        this.unit.airvolume.totalFrZuKorr += +parseFloat(room.getRoomtype().f_zu).toFixed(1)
        this.total_fr_zu_korr += +parseFloat(room.airvolume.fZuKorr).toFixed(1)
      })

      this.unit.rooms.forEach(
        function (room) {
          if (room.airType != 2) return
          var minAirvolume = 0
          var roomAirvolume = 0
          roomAirvolume = Math.round((this.unit.airvolume.nl / this.total_fr_zu_korr) * room.airvolume.fZuKorr)
          minAirvolume = room.getRoomtypeAirvolume()
          room.airvolume.airvolume = roomAirvolume
          if (roomAirvolume < minAirvolume) {
            changes = true
            room.airvolume.fZuKorr = (minAirvolume * this.total_fr_zu_korr) / this.unit.airvolume.nl
            return
          }
          room.airvolume.fZu = room.airvolume.fZuKorr
        }.bind(this)
      )
      this.unit.airvolume.totalSupplyAir = this.unit.airvolume.nl
      if (changes === true && this.i < 10) {
        this.i++
        this.calculateSupplyAir()
      } else {
        this.i = 0
      }
    },
  */

  calculateExhaustAir() {
    this.unit.rooms.forEach(
      function (room) {
        if (room.airType != 1) return
        if (room.ventilationMeasure == 7) {
          room.airvolume.airvolume = 0
          return
        }
        if (room.ventilationMeasure == 6) {
          // get airvolume from operationmode (need_airvolume)
          var operationmodeAirvolume = RoomtypesHasOperationmodesHasAirvolume.find(room.airvolume.operationmodeAirvolume)
          // if operationmodeAirvolume is not set then get default operationmodeAirvolume for this roomtype
          if (operationmodeAirvolume == null || operationmodeAirvolume == undefined) {
            var operationmode = RoomltmsHasOperationmode.query().where('roomltms_id', room.ventilationMeasure).where('default', 1).first()
            room.airvolume.operationmode = operationmode.operationmodes_id
            var operationmodeAirvolume = RoomtypesHasOperationmodesHasAirvolume.query().where('operationmodes_id', room.airvolume.operationmode).where('roomtypes_id', room.type).where('window', +room.window).where('default', true).first()
            room.airvolume.operationmodeAirvolume = operationmodeAirvolume.id

          }
          room.airvolume.airvolume = operationmodeAirvolume.need_airvolume
          return
        }
        room.airvolume.airvolume = room.getRoomtypeAirvolume()
      }.bind(this)
    )
  },

  calculateTotalAirvolumes() {
    this.unit.airvolume.totalSupplyAir = 0
    this.unit.airvolume.totalExhaustAir = 0

    this.unit.rooms.forEach(
      function (room) {
        if (room.ventilationMeasure == 7) {
          room.airvolume.airvolume = 0
          return
        }
        if (room.airType == 2) {
          this.unit.airvolume.totalSupplyAir += parseFloat(room.airvolume.airvolume)
          room.airvolume.nlZu = +parseFloat(room.airvolume.airvolume).toFixed(0)
          room.airvolume.nlAb = '-'
        } else if (room.airType == 1) {
          this.unit.airvolume.totalExhaustAir += parseFloat(room.airvolume.airvolume)
          room.airvolume.nlAb = +parseFloat(room.airvolume.airvolume).toFixed(0)
          room.airvolume.nlZu = '-'
        }
        room.airvolume.rl = room.airvolume.airvolume * this.fLstrl
        room.airvolume.il = room.airvolume.airvolume * this.fLstil
        room.airvolume.fl = room.airvolume.airvolume * this.fLstfl
      }.bind(this)
    )
    this.unit.airvolume.totalSupplyAir = Math.round(this.unit.airvolume.totalSupplyAir)
    this.unit.airvolume.totalExhaustAir = Math.round(this.unit.airvolume.totalExhaustAir)
  },

  calculateAirvolumeVariations() {
    this.unit.airvolume.nl = Math.round(this.unit.airvolume.nl)
    this.unit.airvolume.rl = Math.round(this.unit.airvolume.nl * this.fLstrl)
    this.unit.airvolume.il = Math.round(this.unit.airvolume.nl * this.fLstil)
    this.unit.airvolume.fl = Math.round(this.unit.airvolume.nl * this.fLstfl)

    this.unit.airvolume.nlExchange = +parseFloat(this.unit.airvolume.nl / this.unit.airvolume.volume).toFixed(2)
    this.unit.airvolume.rlExchange = +parseFloat(this.unit.airvolume.rl / this.unit.airvolume.volume).toFixed(2)
    this.unit.airvolume.ilExchange = +parseFloat(this.unit.airvolume.il / this.unit.airvolume.volume).toFixed(2)
    this.unit.airvolume.flExchange = +parseFloat(this.unit.airvolume.fl / this.unit.airvolume.volume).toFixed(2)
  },

  calculateUld() {
    var f_uld = 3.1
    var p_uld = 1.5
    if (this.unit.overflowSeal == 1) var k_dichtung = 25
    if (this.unit.overflowSeal == 0) var k_dichtung = 0

    this.unit.rooms.forEach((room) => {
      var airvolume = 0
      if (room.airvolume.operationmodeAirvolume > 0) airvolume = RoomtypesHasOperationmodesHasAirvolume.find(room.airvolume.operationmodeAirvolume).duration_airvolume
      if (airvolume <= 0 || airvolume == null) airvolume = room.airvolume.airvolume
      if (airvolume <= 0 || airvolume == null) {
        room.airvolume.uld = 0
        return
      }
      room.airvolume.uld = +parseFloat((f_uld * airvolume) / Math.pow(p_uld, 0.5) - k_dichtung).toFixed(0)
    })
  },

  calculateValves() {
    this.unit.rooms.some(
      function (room) {
        if (room.valve.valvesAmmount == null || room.valve.valvesAmmount <= 0) {
          room.valve.valvesAmmount = Math.ceil(room.airvolume.airvolume / 60)
          if (this.unit.systemselection.pipeProfile == 2) {
            room.valve.pipesAmmount = Math.ceil(room.airvolume.airvolume / 20)
          } else {
            room.valve.pipesAmmount = Math.ceil(room.airvolume.airvolume / 30)
          }
          if (room.valve.pipesAmmount < room.valve.valvesAmmount) {
            room.valve.pipesAmmount = room.valve.valvesAmmount
          }
        }
      }.bind(this)
    )
  },
}
